<template>
    <div>
        <multiselect
            :allowEmpty="false"
            :options="goalNames"
            v-model="selectedGoalName"
            :searchable="false"
            :show-labels="false"
            track-by="name"
            label="name"
        >
            <span slot="caret" slot-scope="{ toggle }" class="arrow">
                <img src="/images/caret-down.svg" alt="dropdown select" />
            </span>
        </multiselect>
        <div v-if="series[0].data.length > 0" class="mt-4">
            <div class="chart-title">Goal Metrics Chart</div>
            <apexchart
                type="bar"
                :options="chartOptions"
                :series="series"
                height="340"
                v-if="ready"
            ></apexchart>
        </div>
        <div v-else class="text-center w-100 mt-4">
            No data for selected options
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Multiselect from "vue-multiselect";
import _ from "lodash";

export default {
    name: "GoalMetrics",

    components: {
        apexchart: VueApexCharts,
        Multiselect,
    },

    props: [
        "company",
        "userGroups",
        "currentUser",
        "selectedLeft",
        "selectedRight",
    ],

    data() {
        return {
            totalTasks: 0,
            totalCompletedTasks: 0,
            ready: false,
            goalNames: [
                {
                    id: 0,
                    name: "All",
                },
            ],
            selectedGoalName: {
                id: localStorage.activityChart_selectedGoalId ?? 0,
                name: localStorage.activityChart_selectedGoalName ?? "All",
            },
            series: [
                {
                    name: "",
                    data: [],
                },
            ],
            chartOptions: {
                colors: ["#0f3266", "#00afc5", "#ff0059", "#0db4e6", "#8997aa"],
                chart: {
                    type: "bar",
                    height: 350,
                    stacked: true,
                },
                plotOptions: {
                    bar: {
                        vertical: true,
                    },
                },
                stroke: {
                    show: true,
                    width: 1,
                    colors: ["#fff"],
                },
                title: {
                    text: "",
                },
                xaxis: {
                    title: {
                        text: "Metrics",
                    },
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: "Goal Target Number",
                    },
                    forceNiceScale: true,
                    min: 0,
                    max: 0,
                    labels: {
                        formatter: function (val) {
                            return parseInt(val.toFixed(1));
                        },
                    },
                },
                tooltip: {
                    enabled: false,
                },
                legend: {
                    position: "bottom",
                },
            },
        };
    },

    computed: {
        generatedChartUrl() {
            const baseUrl = `/companies/${this.company.id}/goal-chart?`;
            const queries = Object.keys(this.queries)
                .map((key) => `${key}=${this.queries[key]}`)
                .join("&");

            return baseUrl + queries.replace(" ", "_");
        },

        queries() {
            let buildQuery = {
                range: this.selectedLeft,
                visibility: this.selectedRight.name,
            };

            if (this.selectedGoalName.id !== 0) {
                buildQuery.goal_name_id = this.selectedGoalName.id;
            }

            return buildQuery;
        },
    },

    watch: {
        selectedLeft() {
            this.resetChart();
            this.selectedGoalName = {
                id: 0,
                name: "All",
            };
        },

        selectedRight() {
            this.resetChart();
            this.selectedGoalName = {
                id: 0,
                name: "All",
            };
        },

        selectedGoalName() {
            this.resetChart();
            localStorage.activityChart_selectedGoalName = this.selectedGoalName.name;
            localStorage.activityChart_selectedGoalId = this.selectedGoalName.id;
        },
    },

    methods: {
        async getChartData() {
            const res = await axios.get(this.generatedChartUrl);
            const data = res.data.data;

            Object.values(data).forEach((item) => {
                if (item > this.chartOptions.yaxis.max) {
                    this.chartOptions.yaxis.max = item;
                    this.chartOptions.yaxis.tickAmount =
                        item < 10 ? item : null;
                }
            });

            delete data["target_number"];
            this.series[0].data = Object.values(data);
            this.chartOptions.xaxis.categories = Object.keys(data);

            this.ready = this.series[0].data.length > 0;
        },

        resetChart: _.debounce(function () {
            this.ready = false;
            this.series[0].data = [];
            this.chartOptions.xaxis.categories = [];
            this.chartOptions.yaxis.max = 0;
            delete this.chartOptions.yaxis.tickAmount;

            this.getChartData();
        }, 250),

        async getGoals() {
            this.goalNames = [
                {
                    id: 0,
                    name: "All",
                },
            ];

            const res = await axios.get(
                `/user/${this.currentUser.id}/goal-names`
            );
            const data = res.data.data;

            data.forEach((item) => {
                if (item) {
                  this.goalNames.push({
                    id: item.id,
                    name: item.name,
                  });
                }
            });
        },
    },

    mounted() {
        this.getGoals();
        this.getChartData();
    },
};
</script>

<style scoped>
</style>
